import React from 'react'

import _ from 'lodash'

import {Alert, H3, H5, Row, Card} from '../../../../components/UI/index.js'
import EmailPreview from '../../../../components/settings/EmailPreview.js'
import {formSpacing, FormStack, Input, Editor, UploadImage} from '../../../../components/UI/forms/index.js'
import LoginActions from '../../../../actions/LoginActions.js'
import t from 'src/helpers/Languages.js'

import customerWelcomeTemplate from '../../../../../server/functions/mail/templates/customerWelcomeTemplate.js'
import {welcomeMailPhoto} from '../../../../../utils/trackTraceBranding.js'
import {trackTracePhotoSizes} from '../../../../../types/trackTrace.js'

class CustomerSettings extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            photoError: ''
        }
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    // The photo is saved as a file on the server, which checks the minimum size
    onChangePhoto(dataUrl) {
        this.setState({photoError: ''})

        LoginActions.setTrackTracePhoto('welcomeCustomer', dataUrl || null, (err, id) => {
            if (err) {
                this.setState({photoError: err})
                return
            }

            const reseller = {...this.props.reseller}
            _.set(reseller.settings, 'customers.welcomeEmailPhoto', id || undefined)
            this.props.onChange(reseller)
        })
    }

    render() {
        const {reseller} = this.props
        const {width, height} = trackTracePhotoSizes.welcomeCustomer
        const photo = welcomeMailPhoto(reseller, 'welcomeCustomer')

        return (
            <Row style={{gap: 24}}>
                <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                    <H3 style={{marginBottom: 36}}>{t('settingsCustomers')}</H3>

                    <H5 style={{marginBottom: 24}}>{t('welcomeMail')}</H5>

                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label={t('mailSenderName')}
                            placeholder={reseller.settings?.accountName || reseller.name}
                            value={reseller.settings.customers.senderName}
                            onChange={this.onChangeValue.bind(this, 'customers.senderName')}
                            onBlur={this.onSaveValue.bind(this, 'customers.senderName')}
                        />

                        <Input
                            label={t('mailSenderEmail')}
                            placeholder={reseller.settings.companyAddress.email || (reseller.settings.useOwnSMTP && reseller.settings.smtpUser) || 'noreply@veloyd.nl'}
                            value={reseller.settings.customers.replyToEmail}
                            onChange={this.onChangeValue.bind(this, 'customers.replyToEmail')}
                            onBlur={this.onSaveValue.bind(this, 'customers.replyToEmail')}
                        />
                    </FormStack>

                    <br />
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label={t('mailSubject')}
                            value={reseller.settings.customers.welcomeEmailSubject}
                            onChange={this.onChangeValue.bind(this, 'customers.welcomeEmailSubject')}
                            onBlur={this.onSaveValue.bind(this, 'customers.welcomeEmailSubject')}
                        />

                        <Editor
                            label={t('message')}
                            tags={['bedrijfsnaam', 'klant']}
                            value={reseller.settings.customers.welcomeEmailBody}
                            onChange={this.onSaveValue.bind(this, 'customers.welcomeEmailBody')}
                        />

                        <UploadImage
                            label={t('welcomeMailPhoto')}
                            subText={t('ttsPhotoSize', `${width} × ${height}`)}
                            image={photo}
                            accept='image/png,image/jpeg'
                            resize={false}
                            maxSize={10}
                            onChange={(dataUrl) => this.onChangePhoto(dataUrl)}
                        />
                        {this.state.photoError && <Alert variant='danger'>{this.state.photoError}</Alert>}
                    </FormStack>
                </Card>

                <div style={{width: 650}}>
                    <EmailPreview
                        type='customerWelcome'
                        html={customerWelcomeTemplate({
                            logo: reseller.settings.logo || '/images/logoPlaceholder.png',
                            color: reseller.settings.color,
                            message: reseller.settings.customers.welcomeEmailBody?.replace(/\n/g, '<br/>') || '',
                            token: '',
                            loginEmail: 'klant@voorbeeld.nl',
                            photo
                        }, window.location.origin)}
                    />
                </div>
            </Row>
        )
    }
}

export default CustomerSettings
